'use strict';

function isMultipleOf(n1, n2) {
  return n1 % n2 === 0;
}

module.exports = isMultipleOf;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/internal/isMultipleOf.js
// module id = 104
// module chunks = 0